import {
  AddCustomerSystemFlagReqModel,
  AddDeleteConsumablePartReqModel,
  AuditClosureReviewResModel,
  CardClosureCustomerFlagReqModel,
  CustomerCIRStepReqModel,
  RoutineCustomerStepsResModel,
  RoutineInspectionFlagResModel,
  RoutineWorkCardStepReqModel,
  SendToCustomerRequestModel,
  SendToSelectedPersonaRequestModel,
  UploadFilesReqModel,
  WorkCardFilesReqModel,
  addUpdateCorrosionDelaminationReqModel,
  addUpdateCorrosionDelaminationResModel, LaborClockTrackingReqModel,
} from '../../models/request-payload';
import {
  AuditApprovalStatus,
  PersonaEnum,
  RequestTypeEnum,
  RoutineInspectionFlag,
} from '../../models/mro-enums';
import { Observable, combineLatest, throwError, EMPTY, Subject, lastValueFrom, of } from 'rxjs';
import { catchError, delay, filter, map, switchMap, take } from 'rxjs/operators';

import { ApplicationState } from '../../../../store/application-store';
import { CardStatusReasonList } from '../../models/status-reason-list';
import { CircuitBreakerModel } from '../../models/circuit-breaker';
import { ConcourseApiService } from '../../../../shared/services/concourse-api.service';
import { DataHelper } from '../../services/staar-utils';
import { GetLogPageNumbersResponseModel } from '../../models/log-page-numbers';
import { HttpParams, HttpClient } from '@angular/common/http';
import { HttpService } from '../../../../shared/services/http.service';
import { inject, Injectable } from '@angular/core';
import { PathConstants } from '../../constants/mro-path';
import { PersistedValueEnum } from '../../../../shared/models/persisted-value-enum';
import { DelaminationCorrosionModel, ProjectDetailsWorkCardModel } from '../../models/projectdetails-workcard';
import { ProjectManagementService } from '../../services/project-management.service';
import { ConsumablePartsModel, RequiredPartsModel } from '../../models/my-work-card';
import { Store } from '@ngrx/store';
import { ToolsModel } from '../../models/tools-history';
import { UserAccessorService } from './user-accessor.service';
import { WorkCardFilesModel } from '../../models/project-files';
import { patchWorkCard } from '../../../../store/workcards/workcards.actions';
import { environment } from '../../../../../environments/environment';
import { RefreshForValuesEnum } from '../../constants/refresh-for-values-enum';
import { Router } from '@angular/router';

export type RoutineWorkCardStep = {
  type: 'Routine';
  annotationId: string;
} & Omit<RoutineWorkCardStepReqModel, 'operation' | 'token'>;

export type CustomerCIRStep = {
  type: 'CustomerCIR';
  annotationId: string;
} & Omit<CustomerCIRStepReqModel, 'operation' | 'token'>;

export type WorkCardStatusAndReason = {
  status: string;
  statusReason: string;
  description: string;
};
export interface BasicAnnotation {
  // @todo - tighter type
  type: string;
  documentId: number;
  annotationId: string;
  page: number;
  x: number;
  y: number;
  customData: Record<string, string>;
  cir?: number;
  rtnCardStampsGroupId?: number;
}

export type PreAuditChecklistItem = {
  CHECK_LIST_ITEM: string;
  ITEM_STATUS_FLAG: 'Y' | 'N';
  DIV_NO: number;
  WORK_CARD_ID: number;
};

export type AnnotatedStep = RoutineWorkCardStep | CustomerCIRStep;
export type PersistenceOperation = 'INSERT' | 'UPDATE' | 'DELETE';

export type CIRStep = RoutineCustomerStepsResModel;

@Injectable()
export class WorkCardAccessorService {
  public annotationSaved$: Subject<boolean | string> = new Subject();
  public workCardDetailsV2: string = '';
  customerSystemName: any;
  public networkOnline: boolean = false;
  public updateDialogResult$ = new Subject<boolean>();
  public validationModalData$: Subject<string> = new Subject<string>();
   private useMsWStepsApi;
   private backgroundThreadDelayInMs = 100;
  constructor(
    private concourseApi: ConcourseApiService,
    private httpService: HttpService,
    private dataHelper: DataHelper,
    private userAccessor: UserAccessorService,
    private applicationStore: Store<ApplicationState>,
    private projectMgmtService: ProjectManagementService,
    private router: Router
  ) {

    this.setUseMsWStepsAPI();
    this.projectMgmtService.connectivityShareDataObservable.subscribe(data => {
      this.validationModalData$.next(data);
      localStorage.setItem('networkOnline', data);
    });
  }



  http = inject(HttpClient);
  apiUrl = environment.apimBaseUrl;
  token = sessionStorage.getItem('token');

  setUseMsWStepsAPI(): void{
    let msAPI = JSON.parse(localStorage.getItem('useMsWStepsApiN'));
    if (msAPI && msAPI['useMsWstepsApi'] && msAPI['backgroundThreadDelayInMs']){
      this.useMsWStepsApi = msAPI['useMsWstepsApi'];
      if (this.useMsWStepsApi === 'true'){
        this.backgroundThreadDelayInMs = +msAPI['backgroundThreadDelayInMs'];
      }
    }
  }

  getWorkCardStepDetails(
    workCardId: number,
    persona: PersonaEnum = PersonaEnum.tech,
    cardStepId?: number
  ): Observable<ProjectDetailsWorkCardModel> {
    const employeeInfo = this.userAccessor.getEmployeeInfo();
    const personaFragmentMap = {
      [PersonaEnum.tech]: 'technician',
      [PersonaEnum.kickback]: 'kickback',
      [PersonaEnum.inspector]: 'inspector',
      [PersonaEnum.discrepancy]: 'discrepancy',
    };
    const personaFragment = personaFragmentMap[persona];

    // Include cardStepId only for inspector persona


    // inspection-queue/work-cards && (isDocumentTypeContinuaton || cardtype=nonroutine)  - v2
    const baseUrl ='concourse/staar/project/v2/workCardDetails';

   const personaUrl =personaFragment? `${baseUrl}/${personaFragment}`: baseUrl;


    const commonParam = {
      workCardId,
      token: this.getToken(),
      divNo: employeeInfo.divNo,
      employeeNumber: employeeInfo.employeeNumber
    };

    const personaParams: any = {
      ...commonParam
    };

    // Session StepID is CARD_STEP_ID for digital requests and GROUP_ID for non-digital requests.
    const isDigitalRequest = sessionStorage.getItem('isDigitalRequest') === 'Y';
    const isNonDigitalRequest = sessionStorage.getItem('isDigitalRequest') === 'N';
    const hasStepId = cardStepId !== null && cardStepId !== undefined && !isNaN(cardStepId);
    const routineGroupId = persona === PersonaEnum.inspector && isNonDigitalRequest && hasStepId ? cardStepId : null;

    if (persona === PersonaEnum.inspector && isDigitalRequest && hasStepId) {
      personaParams.cardStepId = cardStepId;
    }

    const params = new HttpParams({
      fromObject: personaParams
    });

    let workDetailsParams;

    let customerRole = localStorage.getItem("userRole");
    if (customerRole === "MRO - CUSTOMER") {
      workDetailsParams = new HttpParams({
        fromObject: {
          workCardId,
          token: this.getToken(),
          divNo: employeeInfo.divNo,
          employeeNumber: employeeInfo.employeeNumber,
          persona: 'customer'
        }
      });
    } else {
      workDetailsParams = new HttpParams({
        fromObject: {
          workCardId,
          token: this.getToken(),
          divNo: employeeInfo.divNo,
          employeeNumber: employeeInfo.employeeNumber
        }
      });
    }

    if (!personaFragment) {
      return this.httpService.get(baseUrl, null, workDetailsParams);
    }

    // Dual call to base and persona-specific endpoints
    return combineLatest([
      this.httpService.get(baseUrl, null, workDetailsParams),
      this.httpService.get(personaUrl, null, params),
    ]).pipe(
      map(([base, specific]) => coalesceObjects(base, specific)),
      map((workCard) =>
        routineGroupId && !workCard.GROUP_ID
          ? { ...workCard, GROUP_ID: routineGroupId }
          : workCard
      )
    );
  }

  getWorkCardDetails(
    workCardId: number,
    persona: PersonaEnum = PersonaEnum.tech
  ): Observable<ProjectDetailsWorkCardModel> {
    const employeeInfo = this.userAccessor.getEmployeeInfo();
    const params = new HttpParams({
      fromObject: {
        workCardId,
        token: this.getToken(),
        divNo: employeeInfo.divNo,
        employeeNumber: employeeInfo.employeeNumber,
        persona: 'customer'
      },
    });

    const baseUrl = '/concourse/staar/project/v2/workCardDetails';
    const personaFragmentMap = {
      [PersonaEnum.tech]: 'technician',
      [PersonaEnum.kickback]: 'kickback',
      [PersonaEnum.inspector]: 'inspector',
      [PersonaEnum.discrepancy]: 'discrepancy',
      [PersonaEnum.customer]: 'customer',
    };
    const personaFragment = personaFragmentMap[persona];

    const personaUrl = personaFragment
      ? `${baseUrl}/${personaFragment}`
      : baseUrl;

    const workCardDetails$ = personaFragment === undefined
      ? this.httpService.get(baseUrl, null, params)
      : combineLatest([
          this.httpService.get(baseUrl, null, params),
          this.httpService.get(personaUrl, null, params),
        ]).pipe(map(([base, specific]) => coalesceObjects(base, specific)));

    return workCardDetails$.pipe(
      switchMap((workCardDetails) =>
        this.getProjectWorkCardListDetails(workCardDetails).pipe(
          map((projectWorkCardDetails) => coalesceObjects(workCardDetails, projectWorkCardDetails)),
          catchError(() => of(workCardDetails))
        )
      )
    );
  }

  private getProjectWorkCardListDetails(
    workCardDetails: ProjectDetailsWorkCardModel
  ): Observable<ProjectDetailsWorkCardModel> {
    if (!workCardDetails?.WORK_CARD_ID || !workCardDetails?.PROJECT_NUMBER) {
      return of(null);
    }

    const query = {
      token: this.getToken(),
      divNo: workCardDetails.DIV_NO,
      projectNo: workCardDetails.PROJECT_NUMBER,
      pageNo: 1,
      pageSize: 1,
      workCardId: workCardDetails.WORK_CARD_ID,
    };

    if (localStorage.getItem('userRole') === 'MRO - CUSTOMER') {
      query['persona'] = 'customer';
    }

    return this.concourseApi
      .getProjectWorkCardDetailsService(
        PathConstants.projectWorkCardList,
        this.dataHelper.constructQueryString(query)
      )
      .pipe(map((response) => response?.paginationData?.[0] ?? null));
  }

  public getDelaminationCorrosionData(
    workCardDetails: ProjectDetailsWorkCardModel){
      this.concourseApi.getCorrosionDelaminationData(
        this.dataHelper.constructQueryString({
          divNo: workCardDetails.DIV_NO,
          workCardId: workCardDetails.WORK_CARD_ID,
          token: this.getToken(),
        })).subscribe(
      response => {
        if(response){
          let DCData: DelaminationCorrosionModel = new DelaminationCorrosionModel();
          DCData.DAMAGE_LOCATION = {
            DISCREPANCY_LINE_ID: response[0].DISCREPANCY_LINE_ID,
            STATION_FROM: response[0].STATION_FROM,
            STATION_TO: response[0].STATION_TO,
            STRINGER_FROM_LEFT_FLAG: response[0].STRINGER_FROM_LEFT_FLAG,
            STRINGER_FROM_RIGHT_FLAG: response[0].STRINGER_FROM_RIGHT_FLAG,
            STRINGER_FROM: response[0].STRINGER_FROM,
            STRINGER_TO_LEFT_FLAG: response[0].STRINGER_TO_LEFT_FLAG,
            STRINGER_TO_RIGHT_FLAG: response[0].STRINGER_TO_RIGHT_FLAG,
            STRINGER_TO: response[0].STRINGER_TO,
            BUTTLINE_FROM_LEFT_FLAG: response[0].BUTTLINE_FROM_LEFT_FLAG,
            BUTTLINE_FROM_RIGHT_FLAG: response[0].BUTTLINE_FROM_RIGHT_FLAG,
            BUTTLINE_FROM: response[0].BUTTLINE_FROM,
            BUTTLINE_TO_LEFT_FLAG: response[0].BUTTLINE_TO_LEFT_FLAG,
            BUTTLINE_TO_RIGHT_FLAG: response[0].BUTTLINE_TO_RIGHT_FLAG,
            BUTTLINE_TO: response[0].BUTTLINE_TO,
            WATER_LINE_FROM: response[0].WATER_LINE_FROM,
            WATER_LINE_TO: response[0].WATER_LINE_TO,
            ENGINEERING_DOCUMENT_FLAG: response[0].ENGINEERING_DOCUMENT_FLAG,
            ENGINEERING_DOCUMENT_DETAILS: response[0].ENGINEERING_DOCUMENT_DETAIL,
            DAMAGE_LOCATION_ID: response[0].DAMAGE_LOCATION_ID
          };

          DCData.DELAMINATION_DATA = {
            removeStructureCompFlag: response[0].REMOVE_STRUCTURE_COMP_FLAG,
            removeStructureCompPart: response[0].REMOVE_STRUCTURE_COMP_PART,
            removeStructureCompSno: response[0].REMOVE_STRUCTURE_COMP_SNO,
            requireSupplementalInspFlag: response[0].REQUIRE_SUPPLEMENTAL_INSP_FLAG,
            supplementInspThreshold: response[0].SUPPLEMENT_INSP_THRESHOLD,
            supplementInspThresholdUnit: response[0].SUPPLEMENT_INSP_THRESHOLD_UNIT,
            supplementInspRepeat: response[0].SUPPLEMENT_INSP_REPEAT,
            supplementInspRepeatUnit: response[0].SUPPLEMENT_INSP_REPEAT_UNIT,
            gougeFlag: response[0].GOUGE_FLAG,
            dentFlag: response[0].DENT_FLAG,
            creaseFlag: response[0].CREASE_FLAG,
            crackFlag: response[0].CRACK_FLAG,
            bulgeFlag: response[0].BULGE_FLAG,
            chafeFlag: response[0].CHAFE_FLAG,
            frettingFlag: response[0].FRETTING_FLAG,
            wrinkleFlag: response[0].WRINKLE_FLAG,
            brokenFlag: response[0].BROKEN_FLAG,
            delaminatedFlag: response[0].DELAMINATED_FLAG,
            otherFlag: response[0].DELAM_OTHER_FLAG,
            otherDescription: response[0].DELAM_OTHER_DESCR,
            srmRepairFlag: response[0].SRM_REPAIR_FLAG,
            srmRepairDetails: response[0].SRM_REPAIR_DETAILS,
            sriRepairFlag: response[0].SRI_REPAIR_FLAG,
            sriRepairDetails: response[0].SRI_REPAIR_DETAILS,
            delaminationId: response[0].DELAMINATION_ID
          };

          DCData.CORROSION_DATA = {
            beyondSrmLimitFlag: response[0].BEYOND_SRM_LIMIT_FLAG,
            blendOut90LimitFlag: response[0].BLEND_OUT_90_LIMIT_FLAG,
            structureReinforcementFlag: response[0].STRUCTURE_REINFORCEMENT_FLAG,
            evidencePreviousBlend: response[0].EVIDENCE_PREVIOUS_BLEND,
            structureReplacedFlag: response[0].STRUCTURE_REPLACED_FLAG,
            leakFlag: response[0].LEAK_FLAG,
            finishFlag: response[0].FINISH_FLAG,
            pluggedDrainFlag: response[0].PLUGGED_DRAIN_FLAG,
            uniqueEventFlag: response[0].UNIQUE_EVENT_FLAG,
            uniqueEventDescription:response[0].UNIQUE_EVENT_DESCRIPTION,
            otherFlag: response[0].CORROSION_OTHER_FLAG,
            otherDescription: response[0].CORROSION_OTHER_DESCR,
            corrosionExtentWideFlag: response[0].CORROSION_EXTENT_WIDE_FLAG,
            corrosionExtentLocalFlag: response[0].CORROSION_EXTENT_LOCAL_FLAG,
            corrosionLevel1Flag: response[0].CORROSION_LEVEL_1_FLAG,
            corrosionLevel2Flag: response[0].CORROSION_LEVEL_2_FLAG,
            partNumber: response[0].PART_NUMBER,
            partDescription: response[0].PART_DESCRIPTION,
            discrCorrosionDetailsId: response[0].CORROSION_ID
          }
           this.applicationStore.dispatch(patchWorkCard({
            workCardId: workCardDetails.WORK_CARD_ID,
            patch: {
              DELAMINATION_CORROSION_DATA : DCData
            }
          }));
        }
      }
    );
  }

  public getULTechStamp(divNo: string, employeeNumber: string): Observable<any> {
    if (this.token !== null && this.token !== undefined)
    {
      let url = `${this.apiUrl}concourse/staar/project/v1/ulTechStamp?divNo=${divNo}&token=${this.token}&employeeNumber=${employeeNumber}`;
      return this.http.get<any>(url);
    }
    return EMPTY;
  }

  updateFinalCustomerPaperworkAudit(
    workCardDetails: ProjectDetailsWorkCardModel,
    toggleValue: boolean
  ): Observable<ProjectDetailsWorkCardModel> {
    return this.concourseApi.updateWorkCards([{
      divNo: workCardDetails.DIV_NO,
      paperWorkFlag: toggleValue ? 'Y' : 'N',
      token: this.getToken(),
      workCardId: workCardDetails.WORK_CARD_ID,
      airworthinessDirectiveFlag: workCardDetails.AIRWORTHINESS_DIRECTIVE_FLAG
    }]).pipe(map(res => {
      if (res && res[0]) {
        const resParams = res[0]
        const result = {
          ...workCardDetails,
          PAPERWORK_FLAG: resParams.paperWorkFlag
        }
        return result
      }
      throw new Error('no response')
    }))
  }

  private async getDialogResult(): Promise<boolean>{
      return lastValueFrom(this.updateDialogResult$.pipe(take(1)));
    }

  getAllDocuments(
    workCardDetails: ProjectDetailsWorkCardModel
  ): Observable<WorkCardFilesModel[]> {
    const query = this.filesListReqQuery(workCardDetails, {
      documentType: '',
    });
    return this.concourseApi
      .getWorkCardFilesList(
        PathConstants.workcardFiles,
        this.dataHelper.constructQueryString(query)
      )
      .pipe(map((res) => res ?? []));
  }

  getWorkCardPdf(
    workCardDetails: ProjectDetailsWorkCardModel
  ): Observable<WorkCardFilesModel> {
    const query = this.filesListReqQuery(workCardDetails, {
      documentType: 'workcard',
    });
    return this.concourseApi
      .getWorkCardFilesList(
        PathConstants.workcardFiles,
        this.dataHelper.constructQueryString(query)
      )
      .pipe(map((res) => (res?.workCardFiles ? res.workCardFiles[0] : null)));
  }

  getAttachments(
    workCardDetails: ProjectDetailsWorkCardModel
  ): Observable<WorkCardFilesModel[]> {
    const query = this.filesListReqQuery(workCardDetails, {
      documentType: 'attachment',
    });
    return this.concourseApi
      .getWorkCardFilesList(
        PathConstants.workcardFiles,
        this.dataHelper.constructQueryString(query)
      )
      .pipe(map((res) => res?.workCardAttachmentFiles ?? []));
  }

  getTechDataFiles(
    workCardDetails: ProjectDetailsWorkCardModel
  ): Observable<WorkCardFilesModel[]> {
    const query = this.filesListReqQuery(workCardDetails, {
      documentType: 'techData',
    });
    return this.concourseApi
      .getWorkCardFilesList(
        PathConstants.workcardFiles,
        this.dataHelper.constructQueryString(query)
      )
      .pipe(map((res) => res?.techDataFiles ?? []));
  }

  public fetchCardClosureSceptreDetails(
    workCardDetails: ProjectDetailsWorkCardModel
  ): Observable<{ required: boolean; enteredBy: string }> {
    const reqModel = new CardClosureCustomerFlagReqModel();
    try {
      const projectDetails = JSON.parse(localStorage.getItem('Pdata'));
      this.customerSystemName = projectDetails.CUSTOMER_DATAENTRY_SYSTEM_NAME;
      reqModel.formId = this.customerSystemName;
    } catch {
      console.error('unable to parse project details from local storage');
    }
    reqModel.token = this.getToken();
    reqModel.divNo = workCardDetails.DIV_NO;
    reqModel.parentId = workCardDetails.WORK_CARD_ID;
    reqModel.customerNo = workCardDetails.CUSTOMER_NUMBER;


    return this.concourseApi
      .getCardClosureSceptreDetails(
        PathConstants.cardClosureSceptreDetails,
        this.dataHelper.constructQueryString(reqModel)
      )
      .pipe(
        map((res) => ({
          required: res?.SCEPTRE_ENTRY_REQUIRED === 'Y',
          enteredBy: res?.SCEPTRE_ENTERED_BY_EMPLOYEE_NAME ?? null,
        }))
      );
  }


  public fetchPreAuditChecklist(
    workCardDetails: ProjectDetailsWorkCardModel
  ): Observable<PreAuditChecklistItem[]> {
    return this.concourseApi
      .getRecordQueueCheckList(
        this.dataHelper.constructQueryString({
          divNo: workCardDetails.DIV_NO,
          workCardId: workCardDetails.WORK_CARD_ID,
          projectNo: workCardDetails.PROJECT_NUMBER,
          token: this.getToken(),
        })
      )
      .pipe(map((res) => res ?? []));
  }

  public fetchLogPages(
    workCardDetails: ProjectDetailsWorkCardModel
  ): Observable<GetLogPageNumbersResponseModel[]> {
    return this.concourseApi
      .getLogPageNumberService(
        PathConstants.getLogPageNumber,
        this.dataHelper.constructQueryString({
          divNo: workCardDetails.DIV_NO,
          workCardId: workCardDetails.WORK_CARD_ID,
          token: this.getToken(),
        })
      )
      .pipe(map((res) => res ?? []));
  }

  public fetchAuditClosureReviews(
    workCardDetails: ProjectDetailsWorkCardModel
  ): Observable<AuditClosureReviewResModel[]> {
    const params = {
      divNo: workCardDetails.DIV_NO,
      token: this.getToken(),
      workCardId: workCardDetails.WORK_CARD_ID,
    };

    const getReviews = () =>
      this.concourseApi.getAuditClosureReview(
        PathConstants.auditClosureReview,
        this.dataHelper.constructQueryString({
          ...params
        })
      );
    return getReviews().pipe(map((results) => results ?? []));
  }

  public fetchAllAuditClosureReview(
    workCardDetails: ProjectDetailsWorkCardModel, verifierType: string): Observable<AuditClosureReviewResModel[]> {
      const params = {
        divNo: workCardDetails.DIV_NO,
        token: this.getToken(),
        workCardId: workCardDetails.WORK_CARD_ID,
        verifierType: verifierType,
      };

      const getReviews = (verifierType: string) =>
        this.concourseApi.getAuditClosureReview(
          PathConstants.auditClosureReview,
          this.dataHelper.constructQueryString({
            ...params,
          })
        );
      return getReviews(verifierType).pipe(map((results) => results ?? []));
  }

  public fetchCircuitBreakers(
    workCardDetails: ProjectDetailsWorkCardModel
  ): Observable<CircuitBreakerModel[]> {
    return this.concourseApi
      .getCircuitBreakers(
        PathConstants.circuitBreakers,
        this.dataHelper.constructQueryString({
          divNo: workCardDetails.DIV_NO,
          workCardId: workCardDetails.WORK_CARD_ID,
          token: this.getToken(),
        })
      )
      .pipe(map((res) => res ?? []));
  }

  public updateSceptreRequirement(
    workCardDetails: ProjectDetailsWorkCardModel,
    required: boolean
  ): Observable<true> {
    const reqModel = new AddCustomerSystemFlagReqModel();
    try {
      const projectDetails = JSON.parse(localStorage.getItem('Pdata'));
      let customerSystemName = projectDetails.CUSTOMER_DATAENTRY_SYSTEM_NAME;
      reqModel.formId = customerSystemName;
    } catch {
      console.error('unable to parse project details from local storage');
    }
    reqModel.token = this.getToken();
    reqModel.divNo = workCardDetails.DIV_NO;
    reqModel.parentId = workCardDetails.WORK_CARD_ID;
    reqModel.data = required ? 'Y' : 'N';

    return this.concourseApi.addSceptreData(reqModel).pipe(
      map((res) => {
        if (res.O_SUCCESS_FLAG === 'N') {
          throw new Error(res.O_ERROR);
        }
        this.concourseApi.clearCardClosureSceptreDetailsCache();
        this.projectMgmtService.shareInspectionQueueData({
            operation: 'SCEPTRE refresh',
            tab: reqModel.data ? 'Y' : 'N',
          });
        return true;
      })
    );
  }

  public addUpdateCorrosionDelamitation(
    addUpdateCorrosionDelaminationReqParams: addUpdateCorrosionDelaminationReqModel
  ): Observable<addUpdateCorrosionDelaminationResModel> {
    return this.concourseApi.addUpdateCorrosionDelamination(addUpdateCorrosionDelaminationReqParams).pipe(
      map((res) => {
        return res;
      })
    );
  }

  private filesListReqQuery(
    workCardDetails: ProjectDetailsWorkCardModel,
    options: Partial<
      Pick<
        WorkCardFilesReqModel,
        'documentType' | 'sortingField' | 'sortingOrder'
      >
    > = {}
  ): WorkCardFilesReqModel {
    if (options?.documentType !== ''){
      return {
        workCardId: workCardDetails.WORK_CARD_ID,
        token: this.getToken(),
        divNo: workCardDetails.DIV_NO,
        sortingField: options?.sortingField || 'uploadedDate',
        sortingOrder: options?.sortingOrder || 'desc',
        documentType: options?.documentType || 'workcard',
      };
    }
    return {
      workCardId: workCardDetails.WORK_CARD_ID,
      token: this.getToken(),
      divNo: workCardDetails.DIV_NO,
      sortingField: options?.sortingField || 'uploadedDate',
      sortingOrder: options?.sortingOrder || 'desc',
      //documentType: options?.documentType || 'workcard',
    };
  }

    getFileAnnotations(
    workCardDetails: ProjectDetailsWorkCardModel,
    fileObject: WorkCardFilesModel
  ): Observable<Blob> {
    const fileName = encodeURIComponent(
      `${fileObject.FILE_NAME}.${fileObject.FILE_EXTENSION}`
    );
    const { WORK_ORDER_NUMBER, ZONE_NUMBER, ITEM_NUMBER } = workCardDetails;
    const workCardIdentifier = `${WORK_ORDER_NUMBER}-${ZONE_NUMBER}-${ITEM_NUMBER}`;

    const objectType = fileObject.OBJECT_TYPE;

    return this.concourseApi.getAnnotationDataService(
      PathConstants.fetchAnnotationDataPath,
      this.dataHelper.constructQueryString({
        projectNo: workCardDetails.PROJECT_NUMBER,
        workCardIdentifier,
        fileName,
        objectType,
      })
    );
  }

  getFileAnnotationsNew(
    workCardDetails: ProjectDetailsWorkCardModel,
    fileId: number,
    objectType: string,
    fileName: string
  ): Observable<any> {
    const newFileName = encodeURIComponent(fileName);
    const projectNumber = workCardDetails.PROJECT_NUMBER ? workCardDetails.PROJECT_NUMBER : workCardDetails['projectNumber'];
    const workCardId = workCardDetails.WORK_CARD_ID ? workCardDetails.WORK_CARD_ID : workCardDetails['workCardId'];
    const divisionNumber = workCardDetails.DIV_NO ? workCardDetails.DIV_NO : workCardDetails['divNo'];
    const workOrderNumber = workCardDetails.WORK_ORDER_NUMBER ? workCardDetails.WORK_ORDER_NUMBER : workCardDetails['workOrderNumber'];
    const zoneNumber = workCardDetails.ZONE_NUMBER ? workCardDetails.ZONE_NUMBER : workCardDetails['zoneNumber'];
    const itemNumber = workCardDetails.ITEM_NUMBER ? workCardDetails.ITEM_NUMBER : workCardDetails['itemNumber'];
    return this.concourseApi.getAnnotationDataServiceNew(
      PathConstants.fetchFileStamps,
      this.dataHelper.constructQueryString({
        projectNumber: projectNumber,
        divisionNumber: divisionNumber,
        workCardId: workCardId,
         objectType,
        fileName,
        workCardIdentifier: `${workOrderNumber}-${zoneNumber}-${itemNumber}`,
        staarFileId: fileId
      })
    );
  }

  getRoutineInspectionFlag(
    workCardDetails: ProjectDetailsWorkCardModel
  ): Observable<RoutineInspectionFlagResModel[]> {
    return this.concourseApi.getRoutineInspectionFlag(
      PathConstants.routineFlagCheck,
      this.dataHelper.constructQueryString({
        divNo: workCardDetails.DIV_NO,
        workCardId: workCardDetails.WORK_CARD_ID,
        projectNo: workCardDetails.PROJECT_NUMBER,
        groupId: workCardDetails.GROUP_ID ?? null,
        token: this.getToken(),
      })
    );
  }

  getCIRSteps(
    workCardDetails: ProjectDetailsWorkCardModel
  ): Observable<CIRStep[]> {

    const isContinuation =  this.router.url.includes('continuation_sheets');
    return (workCardDetails.digitalCardFlag === 'N' || workCardDetails.DIGITAL_CARD_FLAG ==='N') && !isContinuation
      ? this.getRoutineCIRSteps(workCardDetails)
      : this.getNonRoutineCIRSteps(workCardDetails);
  }

  getContinuationSheets(
    workCardDetails: ProjectDetailsWorkCardModel
  ): Observable<CIRStep[]> {
    return this.getRCContinuationSheets(workCardDetails);
  }

  voidCIRStep(
    workCardDetails: ProjectDetailsWorkCardModel,
    customerCardStepId: number,
    description: string = '',
    nrcOrContinuation: boolean = false
  ): Observable<number> {
    const storedUserDetails = JSON.parse(localStorage.getItem(PersistedValueEnum.userDetails));
    if ((workCardDetails.digitalCardFlag === 'N' || workCardDetails.DIGITAL_CARD_FLAG ==='N') && !nrcOrContinuation){
      return this.concourseApi
        .confirmVoidRoutineCIRData({
          divNo: workCardDetails.DIV_NO,
          token: this.getToken(),
          workCardId: workCardDetails.WORK_CARD_ID,
          digitalCardFlag: workCardDetails.digitalCardFlag,
          description,
          operation: 'VOID',
          customerNumber: `${workCardDetails.CUSTOMER_NUMBER}`,
          customerCardStepId,
          customerRepStampNumber: storedUserDetails.stampNumber
        })
        .pipe(
          map((res) => {
            if (res.O_SUCCESS_FLAG === 'N') {
              throw new Error(res.O_ERROR_MESSAGE);
            }
            return res.IO_CUSTOMER_CARD_STEP_ID;
          })
        );
    }else{
      return this.concourseApi
        .confirmVoidCIRData({
          divNo: workCardDetails.DIV_NO,
          token: this.getToken(),
          workCardId: workCardDetails.WORK_CARD_ID,
          description,
          operation: 'DELETE',
          customerNumber: `${workCardDetails.CUSTOMER_NUMBER}`,
          customerCardStepId,
          customerRepStampNumber: storedUserDetails.stampNumber
        })
        .pipe(
          map((res) => {
            if (res.O_SUCCESS_FLAG === 'N') {
              throw new Error(res.O_ERROR_MESSAGE);
            }
          this.projectMgmtService.refreshData(RefreshForValuesEnum.cirUpdate);
            return res.IO_CUSTOMER_CARD_STEP_ID;
          })
        );
    }
  }

   private getRoutineCIRSteps(
    workCardDetails: ProjectDetailsWorkCardModel
  ): Observable<CIRStep[]> {
    this.networkOnline = localStorage.getItem('networkOnline') === 'Okay';
    // A function that returns the API call Observable, used in both paths
    const apiCall$ = this.concourseApi.getRoutineCustomerDesignatorSteps(
      PathConstants.routineCustomerSteps,
      this.dataHelper.constructQueryString({
        divNo: workCardDetails.DIV_NO,
        workCardId: workCardDetails.WORK_CARD_ID,
        sortingField: 'pageNumber',
        sortingOrder: 'asc',
        token: this.getToken(),
        all: true,
      })
    ).pipe(
      // Use catchError to handle any error that occurs during the API call
      catchError(error => {
        console.error("API call failed:", error);
          // Return an empty array Observable when a network error occurs
        return of([]);
      })
    );

    if (this.networkOnline){
         return apiCall$; // Return the API call with error handling
      } else {
        return this.validationModalData$.pipe(
          // Wait for the next emission that equals 'Okay'.
          filter(modalData => modalData === 'Okay'),
          // Only take the first one that matches to avoid re-triggering.
          take(1),
          // Once the condition is met, switch to the API observable with error handling.
          switchMap(() => apiCall$)
        );
      }
  }

  private getNonRoutineCIRSteps(
    workCardDetails: ProjectDetailsWorkCardModel
  ): Observable<CIRStep[]> {
    if (this.useMsWStepsApi === null || this.useMsWStepsApi === undefined) {
      this.setUseMsWStepsAPI();
    }
    if (this.token === null){
      this.token = sessionStorage.getItem('token');
    }
    let workcardStepsReqParams: any = {
      workCardId: workCardDetails.WORK_CARD_ID,
      customerSteps: true,
      eieSteps: true,
      workCardSteps: true,
      all: true,
      sortingField: 'dtCreated',
      sortingOrder: 'ASC'
    };
    let url = `${PathConstants.workCardStepsMS}/project/${workCardDetails['PROJECT_NUMBER']}/division/${workCardDetails['DIV_NO']}/${this.token}/steps`;

     // Use the legacy API when the MS API flag is off.
    if (this.useMsWStepsApi === 'false') {
      workcardStepsReqParams = {
        divNo: workCardDetails.DIV_NO,
        projectNo: workCardDetails.PROJECT_NUMBER,
        workCardId: workCardDetails.WORK_CARD_ID,
        customerSteps: true,
        eieSteps: true,
        workCardSteps: true,
        all: true,
        token: this.token
      };
      url = PathConstants.workCardSteps;
    }
    return this.concourseApi
      .getWorkCardSteps(
        url,
        this.dataHelper.constructQueryString(workcardStepsReqParams)
      )
      .pipe(
        map((res) => res || []),
        map((data) => {
          let allSteps = this.useMsWStepsApi === 'true' ? this.dataHelper.workCardStepsMapping(data.data) : data;
          // CIRs that are not linked to a work-card step.
          let unassigned = allSteps.filter(
            (step) => step.CUSTOMER_CARD_STEPS_ID && !step.CARD_STEP_ID
          );

          unassigned = this.getDistinctByProperty(unassigned, 'CUSTOMER_CARD_STEPS_ID');
          // CIRs linked directly to a work-card step.
          let assigned = allSteps
            .filter((step) => step.CARD_STEP_ID)
            .map((step) => step.CUSTOMER_STEPS || [])
            .flat();
          assigned = this.getDistinctByProperty(assigned, 'CUSTOMER_CARD_STEPS_ID');
          // CIRs linked to an EIE step.
          let eieCirs: CIRStep[] = [];
          allSteps.forEach(step => {
            if (step.EIE_STEPS) {
              step.EIE_STEPS.forEach(eieStep => {
                if (eieStep.CUSTOMER_STEPS) {
                  eieStep.CUSTOMER_STEPS = this.getDistinctByProperty(eieStep.CUSTOMER_STEPS, 'CUSTOMER_CARD_STEPS_ID');
                  eieCirs = eieCirs.concat(eieStep.CUSTOMER_STEPS);
                }
              })
            }
          })
          let actionCirs: any[] = [];
           // Adds CIRs linked to an action or an action EIE.
          const collectActionCirs = (
            parentStep: any,
            parentAction: any,
            actionRow: any
          ): void => {
            const displayStepNumber =
              parentStep.DISPLAY_STEP_NUMBER ??
              parentStep.STEP_INDEX ??
              parentStep.STEP_NUMBER;

            const displayActionNumber =
              actionRow.DISPLAY_ACTION_NUMBER ??
              actionRow.EIE_SOURCE_ACTION_NUMBER ??
              parentAction.DISPLAY_ACTION_NUMBER;

            const customerSteps = Array.isArray(
              actionRow?.CUSTOMER_STEPS
            )
              ? actionRow.CUSTOMER_STEPS
              : [];
             // Marks the CIR as belonging to an action group.
            actionCirs.push(
              ...customerSteps.map((cir: any) => ({
                ...cir,


                isActionGroupCir: true,

                // Use the action or action-EIE group ID as the parent.
                PARENT_STEP_ACTION_GROUP_ID:
                  cir.PARENT_STEP_ACTION_GROUP_ID ??
                  actionRow.CARD_STEP_ACTION_GROUP_ID ??
                  parentAction.CARD_STEP_ACTION_GROUP_ID,

                // Display values such as 1.1 or 1.2 in the sidebar.
                PARENT_CARD_STEP_ID:
                  actionRow.CARD_STEP_ID ??
                  parentAction.CARD_STEP_ID ??
                  parentStep.CARD_STEP_ID,


                PARENT_DISPLAY_STEP_NUMBER:
                  displayStepNumber != null &&
                    displayActionNumber != null
                    ? `${displayStepNumber}.${displayActionNumber}`
                    : '',

                // Used when sorting the CIRs.
                PARENT_STEP_NUMBER:
                  displayStepNumber,

                 // Used to decide whether Accept should be available.
                parentStatus:
                  actionRow.STATUS,

                parentStatusReason:
                  actionRow.STATUS_REASON
              }))
            );
          };

          allSteps.forEach(parentStep => {
            const actionGroups = Array.isArray(
              parentStep?.ACTION_GROUP_JSON
            )
              ? parentStep.ACTION_GROUP_JSON
              : [];

            actionGroups.forEach(parentAction => {
              // CIRs attached directly to the action.
              collectActionCirs(
                parentStep,
                parentAction,
                parentAction
              );

              // CIRs attached to an EIE created from the action.
              const actionEieRows = Array.isArray(
                parentAction?.EIE_STEPS
              )
                ? parentAction.EIE_STEPS
                : [];

              actionEieRows.forEach(actionEieRow => {
                collectActionCirs(
                  parentStep,
                  parentAction,
                  actionEieRow
                );
              });
            });
          });
          const cirsById = new Map<number, any>();

          const addCIRToResult = (
            cir: any,
            source: 'FLAT' | 'ACTION'
          ): void => {
            const customerCardStepId = Number(
              cir?.CUSTOMER_CARD_STEPS_ID
            );

            if (!customerCardStepId) {
              return;
            }

            const existing =
              cirsById.get(customerCardStepId);

            if (!existing || source === 'ACTION') {
              cirsById.set(
                customerCardStepId,
                cir
              );
            }
          };

          [
            ...unassigned,
            ...assigned,
            ...eieCirs
          ].forEach(cir =>
            addCIRToResult(cir, 'FLAT')
          );

          actionCirs.forEach(cir =>
            addCIRToResult(cir, 'ACTION')
          );

          const result =
            Array.from(cirsById.values());

          return result;
        })
      );
  }

  private getDistinctByProperty<T>(array: T[], property: keyof T): T[] {
  const seen = new Map<any, boolean>();
  const distinctArray: T[] = [];
    if (array !== null){
      for (const item of array) {
        const propertyValue = item[property];
        if (!seen.has(propertyValue) || propertyValue === undefined || propertyValue === null) {
          seen.set(propertyValue, true);
          distinctArray.push(item);
        }
      }
    }
  return distinctArray;
}

  private getRCContinuationSheets(
    workCardDetails: ProjectDetailsWorkCardModel
  ): Observable<CIRStep[]> {
    if (this.useMsWStepsApi === null || this.useMsWStepsApi === undefined){
      this.setUseMsWStepsAPI();
    }
    if (this.token === null){
      this.token = sessionStorage.getItem('token');
    }
     let workcardStepsReqParams: any = {
          workCardId: workCardDetails.WORK_CARD_ID,
          customerSteps: true,
          all: true,
          divNo: workCardDetails.DIV_NO,
          projectNo: workCardDetails.PROJECT_NUMBER,
          token: this.token

    };
     let url = `${PathConstants.workCardStepsMS}/project/${workCardDetails['PROJECT_NUMBER']}/division/${workCardDetails['DIV_NO']}/${this.token}/steps`;
    if (this.useMsWStepsApi === 'false'){
       workcardStepsReqParams = {
          divNo: workCardDetails.DIV_NO,
          projectNo: workCardDetails.PROJECT_NUMBER,
          workCardId: workCardDetails.WORK_CARD_ID,
          customerSteps: true,
          eieSteps: true,
          workCardSteps: true,
          all: true,
          token: this.token
    };
      url = PathConstants.workCardSteps;
    }
    return this.concourseApi
      .getWorkCardSteps(
        url,
        this.dataHelper.constructQueryString(workcardStepsReqParams)
      )
      .pipe(
        delay(this.backgroundThreadDelayInMs),
        map((res) => res || []),
        map((allSteps) => {
          let data = this.useMsWStepsApi === 'true' ? this.dataHelper.workCardStepsMapping(allSteps.data): allSteps;
          const unassigned = data.filter(
            (step) => step.DOCUMENT_TYPE === 'CONTINUATION' || (step.CUSTOMER_CARD_STEPS_ID && !step.CARD_STEP_ID)
          );
          return [...unassigned];
        })
      );
  }

  fetchRequiredParts(
    workCardDetails: ProjectDetailsWorkCardModel
  ): Observable<RequiredPartsModel[]> {
    return this.concourseApi
      .getRequiredPartsList(
        PathConstants.workCardPartsList,
        this.dataHelper.constructQueryString({
          pageNo: 1,
          pageSize: 100,
          token: this.getToken(),
          workOrderNumber: workCardDetails.WORK_ORDER_NUMBER,
          projectNumber: workCardDetails.PROJECT_NUMBER,
          divNo: workCardDetails.DIV_NO,
          zoneNumber: workCardDetails.ZONE_NUMBER,
          itemNumber: workCardDetails.ITEM_NUMBER,
        })
      )
      .pipe(map((response) => response?.paginationData || []));
  }

   fetchConsumablePartsList(
    workCardDetails: ProjectDetailsWorkCardModel
  ): Observable<ConsumablePartsModel[]> {
    return this.concourseApi
      .getConsumablePartsList(
        PathConstants.getConsumablePartsList,
        this.dataHelper.constructQueryString({
          token: this.getToken(),
          workCardId: workCardDetails.WORK_CARD_ID,
          divNo: workCardDetails.DIV_NO,
        })
      )
      .pipe(map((response) => response ?? []));
  }

  private fetchToolsByWorkCardId (
    token: string|null,
    workCardId: number,
    divNo: number
  ): Observable<ToolsModel[]> {
    token = token ?? this.getToken();
    return this.concourseApi
      .getTools(
        PathConstants.workcardTools,
        this.dataHelper.constructQueryString({
          token,
          workCardId,
          divNo
        })
      )
      .pipe(map((tools) => tools || []));
  }

  fetchTools(
    workCardDetails: ProjectDetailsWorkCardModel
  ): Observable<ToolsModel[]> {
    return this.fetchToolsByWorkCardId(
      this.getToken(),
      workCardDetails.WORK_CARD_ID,
      workCardDetails.DIV_NO
    );
  }

  fetchToolsByWorkCardAndCheckoutEmployeeId(
    token: string|null,
    workCardId: string,
    divNo: number,
    employeeId: string,
  ): Observable<ToolsModel[]> {
    return this.fetchToolsByWorkCardId(
      token,
      Number(workCardId),
      divNo
    ).pipe(map((tools) =>
        (tools || [])?.
        filter(tool => !tool.CHECK_IN_DATE ).
        filter(tool => tool.CHECKED_TO_EMPLOYEE_NUMBER === employeeId)
      ));
  }

  submitCustomerRoutineInspectionResponse(inspectionParams: {
    workCardDetails?: ProjectDetailsWorkCardModel;
    cirStepsNotStarted?: CIRStep[];
    customerHoldFlags?: RoutineInspectionFlagResModel[];
  }) {
    const { workCardDetails, customerHoldFlags, cirStepsNotStarted } =
      inspectionParams;

    const stepData = cirStepsNotStarted.length ? cirStepsNotStarted[0] : {};

    const activityCode = customerHoldFlags.length
      ? customerHoldFlags[0].REQUEST_TYPE
      : null;

    return this.concourseApi
      .routineStepsGroupActivityService({
        divNo: workCardDetails.DIV_NO,
        workCardId: workCardDetails.WORK_CARD_ID,
        operation: 'UPDATE',
        verifierType: 'CUST_REP',
        verifierApprovalStatus: RoutineInspectionFlag.accept,
        verifierApprovalReason: null,
        rtnCardStampsGroupId: customerHoldFlags.length
          ? customerHoldFlags[0].GROUP_ID
          : null,
        customerCardSteps: [
          {
            customerCardStepId: stepData.CUSTOMER_CARD_STEPS_ID,
          },
        ],
        parentStepId: stepData.PARENT_STEP_ID,
        fallBackCard: 'LAST_LOGON',
        activityCode: 'INSPECTION',
        token: this.getToken(),
      })
      .pipe(
        map((res) => {
          if (res.O_SUCCESS_FLAG === 'Y') {
            /*START : Code logic added for Bug- 36417 */
            if (
              cirStepsNotStarted.length === 1 &&
              customerHoldFlags[0].REQUEST_TYPE === RequestTypeEnum.finalBuyback
            ) {
              this.projectMgmtService.updateWCStatusAndReason('resubmit');
            }
            /*END : Code logic added for Bug- 36417 */
            return true;
          }
          throw new Error(res.O_ERROR_MESSAGE);
        }),
        catchError(error => {
          console.error('API submission failed:', error)
          return throwError(() => error)
        })
      );
  }

  requestWorkCardPDFAccess(workCardFile: WorkCardFilesModel) {
    return this.workCardPDFAccess({
      divNo: workCardFile.DIV_NO,
      fileId: workCardFile.ID,
      signOut: 'N',
    });
  }

  releaseWorkCardPDFAccess(workCardFile: WorkCardFilesModel) {
    return this.workCardPDFAccess({
      divNo: workCardFile.DIV_NO,
      fileId: workCardFile.ID,
      signOut: 'Y',
    });
  }

  uploadAttachments(
    workCardDetails: ProjectDetailsWorkCardModel,
    files: File[],
    fileNameOverrides: string[] = []
  ): Observable<boolean> {
    const payload: Omit<UploadFilesReqModel, 'id' | 'fileName'> = {
      divNo: workCardDetails.DIV_NO,
      parent: 'PR_WORK_CARDS',
      operation: 'INSERT',
      objectType: 'MAINT-WORKSHEETS',
      parentId: workCardDetails.WORK_CARD_ID,
      workCardIdentifier:
        workCardDetails.WORK_ORDER_NUMBER +
        '-' +
        workCardDetails.ZONE_NUMBER +
        '-' +
        workCardDetails.ITEM_NUMBER,
      projectNo: workCardDetails.PROJECT_NUMBER,
      token: this.getToken(),
    };

    const formData = new FormData();
    files.forEach((file, idx) => {
      const fileName = fileNameOverrides[idx] || file.name;
      formData.append('files', file, fileName);
    });

    formData.append('input', `[${JSON.stringify(payload)}]`);
    return this.concourseApi
      .uploadFiles(PathConstants.uploadFiles, formData)
      .pipe(
        map((res) => {
          const failedUploads = res?.length
            ? res.filter((f) => f.successFlag === 'N').map((f) => f.fileName)
            : files.map((f) => f.name);

          if (failedUploads.length) {
            throw new Error(
              'Failed uploading one or more of the following files:' +
                failedUploads.join(', ')
            );
          }

          return true;
        })
      );
  }

  generateContinuationSheet(
    workCardDetails: ProjectDetailsWorkCardModel
  ): Observable<boolean> {
    return this.concourseApi
      .generateContinuationSheet({
        token: this.getToken(),
        divNo: workCardDetails.DIV_NO,
        workCardId: `${workCardDetails.WORK_CARD_ID}`,
        projectNo: workCardDetails.PROJECT_NUMBER,
        workOrderNumber: workCardDetails.WORK_ORDER_NUMBER,
        zoneNumber: workCardDetails.ZONE_NUMBER,
        itemNumber: workCardDetails.ITEM_NUMBER,
        serialNo: `${workCardDetails.SERIAL_NUMBER_WITH_PREFIX}`,
        customerNo: `${workCardDetails.CUSTOMER_NUMBER}`,
        customerCardNo: workCardDetails.CUSTOMER_WORK_CARD,
      })
      .pipe(
        map((res) => {
          if (res?.success === true) {
            return true;
          }

          throw new Error(res.message);
        })
      );
  }

  getTechLibraryDocuments(): Observable<string[]> {
    let userDivNo = localStorage.getItem('divNo');
    const apiPath =
      'concourse/staar/pdftron/v1/listTechLibraryDocuments?divNo=' + userDivNo;
    return this.httpService.get(apiPath);
  }

   addDeleteConsumablePart(
    payloadData: AddDeleteConsumablePartReqModel
  ): Observable<any> {
    payloadData.token = this.getToken();
    return this.concourseApi
      .addDeleteConsumablePart(
        payloadData
      )
      .pipe(map((response) => response ?? []));
  }

  addTechLibraryDocuments(
    workCardDetails: ProjectDetailsWorkCardModel,
    documents: string[]
  ): Observable<string[]> {
    const payload = documents.map((document) => ({
      divNo: workCardDetails.DIV_NO,
      parent: 'PR_WORK_CARDS',
      operation: 'INSERT',
      parentId: workCardDetails.WORK_CARD_ID,
      workCardIdentifier:
        workCardDetails.WORK_ORDER_NUMBER.toString() +
        '-' +
        workCardDetails.ZONE_NUMBER.toString() +
        '-' +
        workCardDetails.ITEM_NUMBER.toString(),
      projectNo: workCardDetails.PROJECT_NUMBER,
      objectType: 'MAINT-WORKSHEETS',
      token: this.getToken(),
      fileName: document,
    }));

    return this.concourseApi.uploadTechLibrary(payload).pipe(
      map((resDocs) => {
        const failures = resDocs.filter((doc) => doc.successFlag === 'N');
        const successes = resDocs.filter((doc) => doc.successFlag === 'Y');

        if (failures.length) {
          // ideally a more elegant way to handle multiple failures
          throw new Error(failures[0].message);
        }

        return successes.map((doc) => doc.fileName);
      })
    );
  }

  sendToCustomerAndUpdateStatus(
    apiPayload: SendToCustomerRequestModel,
    workCardDetails: ProjectDetailsWorkCardModel,
    updates: {
      status: string;
      reason: string;
      correctiveAction?: string;
    }
  ): Observable<ProjectDetailsWorkCardModel> {
    return this.concourseApi
      .sendWorkCardToCustomer(apiPayload)
      .pipe(
        map((res) => {
          if (res.O_SUCCESS_FLAG === 'Y') {
            return {
              ...workCardDetails,
              WIP_STATUS: updates.status,
              WIP_REASON: updates.reason,
              CORRECTIVE_ACTION: updates.correctiveAction,
            };
          }
          throw new Error(res.O_ERROR_MESSAGE);
        })
      );
  }

  sendToSelectedPersona(
    payload: SendToSelectedPersonaRequestModel,
    workCardDetails: ProjectDetailsWorkCardModel,
    persona: PersonaEnum = PersonaEnum.tech
  ): Observable<ProjectDetailsWorkCardModel> {
    return this.concourseApi.sendToSelectedPersona(payload).pipe(
      switchMap((res) => {
        if (res?.O_SUCCESS_FLAG !== 'Y') {
          throw new Error(res?.O_ERROR_MESSAGE || 'Unable to send work card');
        }

        return this.getWorkCardDetails(workCardDetails.WORK_CARD_ID, persona);
      })
    );
  }

   updateWipStatus(
    workCardDetails: ProjectDetailsWorkCardModel,
    updates: {
      status: string;
      reason: string;
      correctiveAction?: string;
    }
  ): Observable<ProjectDetailsWorkCardModel> {
    const { divNo } = this.userAccessor.getEmployeeInfo();
    return this.concourseApi
      .withdrawCard({
        status: updates.status,
        reason: updates.reason,
        correctiveAction: updates.correctiveAction || '',
        statusType: workCardDetails.STATUS,
        parentId: workCardDetails.WORK_CARD_ID,
        statusReasonList: true,
        token: this.userAccessor.getToken().token,
        divNo,
      })
      .pipe(
        map((res) => {
          if (res.O_SUCCESS_FLAG === 'Y') {
            return {
              ...workCardDetails,
              WIP_STATUS: updates.status,
              WIP_REASON: updates.reason,
              CORRECTIVE_ACTION: updates.correctiveAction,
            };
          }
          throw new Error(res.O_ERROR_MESSAGE);
        })
      );
  }

  updateWipLeadStatus(
    workCardDetails: ProjectDetailsWorkCardModel,
    updates: {
      status: string;
      reason: string;
      correctiveAction?: string;
    }
  ): Observable<ProjectDetailsWorkCardModel> {
    const { divNo } = this.userAccessor.getEmployeeInfo();
    return this.concourseApi
      .callSupervisorSendCardToLead({
        statusReason: updates.reason,
        workCardId: workCardDetails.WORK_CARD_ID,
        token: this.userAccessor.getToken().token,
        divNo,
        supervisorReview: 'N',
      })
      .pipe(
        map((res) => {
          if (res.O_SUCCESS_FLAG === 'Y') {
            return {
              ...workCardDetails,
              WIP_STATUS: updates.status,
              WIP_REASON: updates.reason,
              CORRECTIVE_ACTION: updates.correctiveAction,
            };
          }
          throw new Error(res.O_ERROR_MESSAGE);
        })
      );
  }

  updateWipSupervisorStatus(
    updates,
    payload
  ): Observable<any> {

    return this.concourseApi
      .setSupervisorReviewAudit(payload).pipe(
        map((res) => {
          if (res.O_SUCCESS_FLAG === 'Y') {
            return {
              WIP_STATUS: updates.status,
              WIP_REASON: updates.reason,
              CORRECTIVE_ACTION: updates.correctiveAction,
            };
          }
          throw new Error(res.O_ERROR_MESSAGE);
        })
      )
  }

  completeSupervisorReview(
    workCardDetails: ProjectDetailsWorkCardModel
  ): Observable<ProjectDetailsWorkCardModel> {
    const { divNo } = this.userAccessor.getEmployeeInfo();
    return this.concourseApi
      .submitClosureReview({
        divNo,
        workCardId: workCardDetails.WORK_CARD_ID,
        token: this.getToken(),
      })
      .pipe(
        map((res) => {
          if (res?.O_SUCCESS_FLAG === 'N') {
            throw new Error(res.O_ERROR_MESSAGE);
          }
          return {
            ...workCardDetails,
            WIP_STATUS: 'HOLD',
            WIP_REASON: 'AUDIT',
          };
        })
      );
  }

  getAvailableWipStatuses(
    workCardDetails: ProjectDetailsWorkCardModel
  ): Observable<CardStatusReasonList[]> {
    const { divNo } = this.userAccessor.getEmployeeInfo();
    const params = {
      divNo,
      status: workCardDetails.WIP_STATUS,
      statusReason: workCardDetails.WIP_REASON,
      token: this.userAccessor.getToken().token,
      workCardId: workCardDetails.WORK_CARD_ID,
    };
    return this.concourseApi
      .statusReasonList(params)
      .pipe(map((res) => res.cardStatusReasonList));
  }

  private workCardPDFAccess(reqParams) {
    const defaultParams = {
      programId: 'projectWorkCardList',
      terminalId: 'ATVDI-3',
      token: this.getToken(),
      signOut: 'N',
    };
    return this.concourseApi
      .workCardPDFAccess({ ...defaultParams, ...reqParams })
      .pipe(
        map((res) => {
          if (res.O_SUCCESS_FLAG === 'Y') {
            return true;
          }
          throw new Error(res.O_ERROR_MESSAGE);
        })
      );
  }

  public acceptCIRRoutine(
    annotation: BasicAnnotation,
    workCardDetails: ProjectDetailsWorkCardModel,
    routineFlags: RoutineInspectionFlagResModel[]
  ) {
    const paramsPatch: Partial<RoutineWorkCardStepReqModel> = {};
    if (routineFlags?.length) {
      paramsPatch.groupId = routineFlags[0].GROUP_ID;
    }

    return this.persistRoutineWorkCardStep({
      operation: 'INSERT',
      annotation,
      workCardDetails,
      paramsPatch,
    });
  }

  public acceptCIRNonRoutine(
    workCardDetails: ProjectDetailsWorkCardModel,
    cirStep: RoutineCustomerStepsResModel,
    operation: string
  ): Observable<number> {
    const storedUserDetails = JSON.parse(localStorage.getItem(PersistedValueEnum.userDetails));
    let cirReq: CustomerCIRStepReqModel = new CustomerCIRStepReqModel();
    cirReq.divNo= workCardDetails.DIV_NO;
    cirReq.workCardId= workCardDetails.WORK_CARD_ID;
    cirReq.description= cirStep.DESCRIPTION;
    cirReq.token = this.getToken();
    cirReq.digitalCardFlag = workCardDetails.digitalCardFlag;
    cirReq.customerNumber= `${workCardDetails.CUSTOMER_NUMBER}`;
    cirReq.customerCardStepId= cirStep.CUSTOMER_CARD_STEPS_ID;
    cirReq.customerRepStampNumber= storedUserDetails.stampNumber ;
    cirReq.operation = operation;
    if (operation === 'UPDATE'){
      cirReq.approvalStatus = 'ACCEPT';
      cirReq.approvalReason = null;
      cirReq.fallBackCard = 'LAST_LOGON';
      cirReq.parentStepId = cirStep.PARENT_STEP_ID;
    }
    return this.concourseApi
      .addCustomerCIRStep(cirReq)
      .pipe(
        map((res) => {
          if (res?.O_SUCCESS_FLAG === 'Y') {
            return res.IO_CUSTOMER_CARD_STEP_ID;
          }
          throw new Error(res.O_ERROR_MESSAGE);
        })
      );
  }

  public acceptCIRActionGroup(
  workCardDetails: ProjectDetailsWorkCardModel,
  cirStep: RoutineCustomerStepsResModel & {
    PARENT_STEP_ACTION_GROUP_ID?: number;
  },
  operation: string
): Observable<number> {
  const parentStepActionGroupId = Number(
    cirStep.PARENT_STEP_ACTION_GROUP_ID
  );

  if (!parentStepActionGroupId) {
    throw new Error(
      'Parent action group ID is missing.'
    );
  }

  const storedUserDetails = JSON.parse(
    localStorage.getItem(
      PersistedValueEnum.userDetails
    ) || '{}'
  );

  const cirReq: CustomerCIRStepReqModel =
    new CustomerCIRStepReqModel();

  cirReq.divNo =
    workCardDetails.DIV_NO;

  cirReq.workCardId =
    workCardDetails.WORK_CARD_ID;

  cirReq.description =
    cirStep.DESCRIPTION;

  cirReq.token =
    this.getToken();

  cirReq.digitalCardFlag =
    workCardDetails.digitalCardFlag;

  cirReq.customerNumber =
    `${workCardDetails.CUSTOMER_NUMBER}`;

  cirReq.customerCardStepId =
    cirStep.CUSTOMER_CARD_STEPS_ID;

  cirReq.customerRepStampNumber =
    storedUserDetails?.stampNumber;

  cirReq.operation =
    operation;

  cirReq.parentStepActionGroupId =
    parentStepActionGroupId;
  cirReq.cardStepActionGroupId =
    parentStepActionGroupId;

  if (operation === 'UPDATE') {
    cirReq.approvalStatus =
      'ACCEPT';

    cirReq.approvalReason =
      null;

    cirReq.fallBackCard =
      'LAST_LOGON';
  }

  return this.concourseApi
    .addCustomerCIRActionGroupStep(cirReq)
    .pipe(
      map(response => {
        if (
          response?.O_SUCCESS_FLAG === 'Y'
        ) {
          return response
            .IO_CUSTOMER_CARD_STEP_ID;
        }
      })
    );
}
  public addRoutineWorkCardStep(
    annotation: BasicAnnotation,
    workCardDetails: ProjectDetailsWorkCardModel
  ): Observable<number> {
    return this.persistRoutineWorkCardStep({
      operation: 'INSERT',
      annotation,
      workCardDetails,
    }).pipe(
      catchError((error) => {
        console.error('Error in addRoutineWorkCardStep:', error);
        return throwError(() => new Error('API failed in addRoutineWorkCardStep'));
      })
    );
  }

  public updateRoutineWorkCardStepWithXfdf(
    annotation: BasicAnnotation,
    workCardDetails: ProjectDetailsWorkCardModel,
    fileObject: WorkCardFilesModel,
    xfdfBlob: Blob,
    newStampString: String
  ): Observable<{
    IO_RTN_CARD_STAMPS_ACTIVITY_ID: number;
    xfdfUpdated: boolean;
  }> {
    return this.persistRoutineWorkCardStepWithXfdf({
      operation: 'UPDATE',
      annotation,
      workCardDetails,
      fileObject,
      xfdfBlob,
      newStampString
    });
  }

  public deleteRoutineWorkCardStepWithXfdf(
    annotation: BasicAnnotation,
    workCardDetails: ProjectDetailsWorkCardModel,
    fileObject: WorkCardFilesModel,
    xfdfBlob: Blob,
    newStampString?: String
  ): Observable<{
    IO_RTN_CARD_STAMPS_ACTIVITY_ID: number;
    xfdfUpdated: boolean;
  }> {
    return this.persistRoutineWorkCardStepWithXfdf({
      operation: 'DELETE',
      annotation,
      workCardDetails,
      fileObject,
      xfdfBlob,
      newStampString,
    });
  }

  public addRoutineCustomerCirStep(
    annotation: BasicAnnotation,
    workCardDetails: ProjectDetailsWorkCardModel
  ) {
    return this.persistRoutineCustomerCirStep({
      operation: 'INSERT',
      annotation,
      workCardDetails,
    });
  }

    public updateCustomerReviewFlag(
      workCardDetails: ProjectDetailsWorkCardModel,
      value: boolean){
        this.concourseApi.updateWorkCards([{
        divNo: workCardDetails.DIV_NO,
        customerReviewFlag: value ? 'Y' : 'N',
        token: this.getToken(),
        workCardId: workCardDetails.WORK_CARD_ID
      }]).subscribe(
        apiResponse => {
          if(apiResponse){
            this.applicationStore.dispatch(patchWorkCard({
              workCardId: workCardDetails.WORK_CARD_ID,
              patch: {
                CUSTOMER_REVIEW_FLAG : value ? 'Y' : 'N'
              }
            }));
          }
        }
      );
    }

  public updateRoutineCustomerCirStepWithXfdf(
    annotation: BasicAnnotation,
    workCardDetails: ProjectDetailsWorkCardModel,
    fileObject: WorkCardFilesModel,
    xfdfBlob: Blob,
    newStampString: String
  ): Observable<{
    IO_CUSTOMER_CARD_STEP_ID: number;
    xfdfUpdated: boolean;
  }> {
    return this.persistRoutineCustomerCirStepWithXfdf({
      operation: 'UPDATE',
      annotation,
      workCardDetails,
      fileObject,
      xfdfBlob,
      newStampString,
    });
  }

  public deleteRoutineCustomerCirStepWithXfdf(
    annotation: BasicAnnotation,
    workCardDetails: ProjectDetailsWorkCardModel,
    fileObject: WorkCardFilesModel,
    xfdfBlob: Blob,
    newStampString: String,
  ): Observable<{
    IO_CUSTOMER_CARD_STEP_ID: number;
    xfdfUpdated: boolean;
  }> {
    return this.persistRoutineCustomerCirStepWithXfdf({
      operation: 'DELETE',
      annotation,
      workCardDetails,
      fileObject,
      xfdfBlob,
      newStampString
    });
  }

  updateAuditProcess(
    workCardDetails: ProjectDetailsWorkCardModel,
    params: {
      verifierType: string;
      approvalStatus: AuditApprovalStatus;
      correctiveAction?: string;
      approvalReason?: string;
      cardErrorReferenceId?: string;
    }
  ): Observable<boolean> {
    return this.concourseApi
      .auditProcessActivity({
        cardErrorReferenceId: params.cardErrorReferenceId,
        divNo: workCardDetails.DIV_NO,
        token: this.getToken(),
        verifierApprovalStatus: params.approvalStatus,
        verifierApprovalReason: params.approvalReason,
        workCardId: `${workCardDetails.WORK_CARD_ID}`,
        verifierType: params.verifierType,
        correctiveAction: params.correctiveAction,
      })
      .pipe(
        map((res) => {
          if (res.O_SUCCESS_FLAG === 'Y') {
            return true;
          }
          throw new Error(res.O_ERROR_MESSAGE);
        })
      );
  }

  private persistRoutineWorkCardStep(params: {
    operation: PersistenceOperation;
    annotation: BasicAnnotation;
    workCardDetails: ProjectDetailsWorkCardModel;
    paramsPatch?: Partial<RoutineWorkCardStepReqModel>;
  }): Observable<number> {
    const { operation, annotation, workCardDetails, paramsPatch } = params;
    const reqParams = {
      ...this.createRoutineStepParams(operation, workCardDetails, annotation),
      ...(paramsPatch ?? {}),
    };

    return this.concourseApi
    .addUpdateDeleteRoutineWorkCardSteps(reqParams)
    .pipe(
      map((res) => {
        if (res.O_SUCCESS_FLAG === 'Y') {
          return res.IO_RTN_CARD_STAMPS_ACTIVITY_ID;
        }
        throw new Error(res.O_ERROR_MESSAGE || 'Unknown error occurred');
      }),
      catchError((err) => {
        console.error('Error in addRoutineWorkCardStep:', err);
        return throwError(() => new Error('API failed in addRoutineWorkCardStep'));
      })
    );
  }

  private persistRoutineWorkCardStepWithXfdf(params: {
    operation: PersistenceOperation;
    annotation: BasicAnnotation;
    workCardDetails: ProjectDetailsWorkCardModel;
    fileObject: WorkCardFilesModel;
    xfdfBlob: Blob;
    newStampString: String;
  }) {
    const { operation, annotation, workCardDetails, fileObject, xfdfBlob, newStampString } =
      params;
    return this.persistRoutineWorkCardStep({
      operation,
      annotation,
      workCardDetails,
    }).pipe(
      switchMap((id) =>
        this.saveAnnotationFile(workCardDetails, fileObject, xfdfBlob, newStampString).pipe(
          map((xfdfUpdated) => ({
            xfdfUpdated,
            IO_RTN_CARD_STAMPS_ACTIVITY_ID: id,
          }))
        )
      )
    );
  }

  private persistRoutineCustomerCirStep(params: {
    operation: PersistenceOperation;
    annotation: BasicAnnotation;
    workCardDetails: ProjectDetailsWorkCardModel;
  }): Observable<number> {
    const { operation, annotation, workCardDetails } = params;
    const token = this.getToken();
    const storedUserDetails = JSON.parse(localStorage.getItem(PersistedValueEnum.userDetails));
    const reqParams = {
      token,
      operation,
      divNo: workCardDetails.DIV_NO,
      workCardId: workCardDetails.WORK_CARD_ID,
      customerNumber: String(workCardDetails.CUSTOMER_NUMBER),
      customerCardStepId:
      annotation.customData.IO_CUSTOMER_CARD_STEP_ID ?? null,
      digitalCardFlag: workCardDetails.digitalCardFlag,
      description: 'CUST STEP FOR ROUTINE CARDS',
      parent: 'PR_RTN_CARD_STAMP_GRP_ACTION',
      positionX: annotation.x,
      positionY: annotation.y,
      pageNumber: annotation.page,
      documentId: annotation.documentId,
      annotationType: 'DESIGNATOR',
      customerRepStampNumber: storedUserDetails.stampNumber
    };
    if (operation === 'DELETE'){
      return this.concourseApi.deleteCustomerCIRStep(reqParams).pipe(
        map((res) => {
          if (res.O_SUCCESS_FLAG === 'Y') {
            return res.IO_CUSTOMER_CARD_STEP_ID;
          }
          throw new Error(res.O_ERROR_MESSAGE);
        })
      );
    }else{
      if (operation !== 'UPDATE') {
        this.addDesignatorToStampTable(params.operation, params.annotation, params.workCardDetails);
      }
      return this.concourseApi.addCustomerCIRStep(reqParams).pipe(
        map((res) => {
          if (res.O_SUCCESS_FLAG === 'Y') {
            return res.IO_CUSTOMER_CARD_STEP_ID;
          }
          throw new Error(res.O_ERROR_MESSAGE);
        })
      );
    }
  }

  // Method that calls endpoint to add DESIGNATOR annotation to the routine work card stamps table
  addDesignatorToStampTable(operation, annotation, workCardDetails): any {
      const params = { operation, annotation, workCardDetails }
      this.persistRoutineWorkCardStep(params).subscribe((res) => {
        return res;
      }, (error) => {
        console.error(error);
      })
  }

  private persistRoutineCustomerCirStepWithXfdf(params: {
    operation: PersistenceOperation;
    annotation: BasicAnnotation;
    workCardDetails: ProjectDetailsWorkCardModel;
    fileObject: WorkCardFilesModel;
    xfdfBlob: Blob;
    newStampString?: String;
  }) {
    const { operation, annotation, workCardDetails, fileObject, xfdfBlob, newStampString } =
      params;
    return this.persistRoutineCustomerCirStep({
      operation,
      annotation,
      workCardDetails
    }).pipe(
      switchMap((id) =>
        this.saveAnnotationFile(workCardDetails, fileObject, xfdfBlob, newStampString).pipe(
          map((xfdfUpdated) => ({
            xfdfUpdated,
            IO_CUSTOMER_CARD_STEP_ID: id,
          }))
        )
      )
    );
  }

  public newStampOrchestration(
    workCardDetails: ProjectDetailsWorkCardModel,
    fileObject: WorkCardFilesModel,
    newStampString?: String,
    annotation?: BasicAnnotation,
    rtnCardStampsGroupId?: number,
    cir?: number
  ) {
    const payload = {
      "workCardId": workCardDetails.WORK_CARD_ID,
      "divNo": workCardDetails.DIV_NO,
      "staarFileId": fileObject.ID,
      "workCardIdentifier": workCardDetails.WORK_ORDER_NUMBER +
            '-' +
            workCardDetails.ZONE_NUMBER +
            '-' +
        workCardDetails.ITEM_NUMBER,
      "token": this.getToken(),
      "operation": "INSERT",
      "documentId": fileObject.ID,
      "customerNumber": `${workCardDetails.CUSTOMER_NUMBER}`,
      "customerCardStepId": cir ?? annotation.customData.IO_CUSTOMER_CARD_STEP_ID ?? null,
      "description": "CUST STEP FOR ROUTINE CARDS",
      "parent": "PR_RTN_CARD_STAMP_GRP_ACTION",
      "annotationType": "STAMP",
      "customerRepStampNumber": JSON.parse(localStorage.getItem(PersistedValueEnum.userDetails)).stampNumber,
      "verifierType": "CUST_REP",
      "activityCode": "INSPECTION",
      "customerCardSteps": [{"customerCardStepId": cir ?? annotation.customData.IO_CUSTOMER_CARD_STEP_ID ?? null}],
      "fallBackCard": "LAST_LOGON",
      "parentStepId": annotation.customData.PARENT_STEP_ID ?? null,
      "rtnCardStampsGroupId": rtnCardStampsGroupId ?? annotation.customData.IO_RTN_CARD_STAMPS_GROUP_ID ?? null,
      "verifierApprovalStatus": "ACCEPT",
      "verifierApprovalReason": null,
      "rtnCardStampsActivityId": "",
      "stampNumber": "",
      "documentType": "",
      "projectNo": workCardDetails.PROJECT_NUMBER,
      "objectType": fileObject.OBJECT_TYPE,
      "fileName": `${fileObject.FILE_NAME}.${fileObject.FILE_EXTENSION}`,
      "annotationCommand": newStampString
    }
    return this.concourseApi.newStampOrchestrationSave(payload)
  }

  public saveAnnotationFile(
    workCardDetails: ProjectDetailsWorkCardModel,
    fileObject: WorkCardFilesModel,
    xfdfBlob?: Blob,
    newStampString?: String
  ) {
    const pdfFileName = `${fileObject.FILE_NAME}.${fileObject.FILE_EXTENSION}`;
    const queryString = this.dataHelper.constructQueryString({
      projectNo: workCardDetails.PROJECT_NUMBER,
      workCardIdentifier:
        workCardDetails.WORK_ORDER_NUMBER +
        '-' +
        workCardDetails.ZONE_NUMBER +
        '-' +
        workCardDetails.ITEM_NUMBER,
      fileName: pdfFileName,
      objectType: fileObject.OBJECT_TYPE,
      annotCommand: newStampString,
    });

    const obj = {
      "divisionNumber": workCardDetails.DIV_NO,
      "projectNumber": workCardDetails.PROJECT_NUMBER,
      "workCardIdentifier":workCardDetails.WORK_ORDER_NUMBER +
            '-' +
            workCardDetails.ZONE_NUMBER +
            '-' +
            workCardDetails.ITEM_NUMBER,
      "workCardId": workCardDetails.WORK_CARD_ID,
      "staarFileId": fileObject.ID,
      "objectType": fileObject.OBJECT_TYPE,
      "fileName": pdfFileName,
      "annotationCommand": newStampString
    }
    const finalJsonString = JSON.stringify(obj);
     this.networkOnline = localStorage.getItem('networkOnline') === 'Okay';
   if (this.networkOnline){
      return this.concourseApi
      .uploadAnnotationXmlServiceNew(finalJsonString)
      .pipe(
        map((res) => {
          if (res.message) {
            this.annotationSaved$.next(res.message)
            throw new Error(res.message);
          }else{
            this.annotationSaved$.next(true);
          }
          return true;
        })
      );
   }else{
    return this.validationModalData$.pipe(
      // Wait for the next emission that equals 'Okay'.
      filter(modalData => {
        return modalData === 'Okay'}),
      // Only take the first one that matches to avoid re-triggering.
      take(1),
      // Once the condition is met, switch to the API observable.
      switchMap(() => this.concourseApi.uploadAnnotationXmlServiceNew(finalJsonString)),
      // Continue with your original pipeline for the API response.
      map((res) => {

        if (res.message) {
          this.annotationSaved$.next(res.message)
          throw new Error(res.message);
        }else{
          this.annotationSaved$.next(true);
        }
        return true;
      })
    );
   }
  }

  private createRoutineStepParams(
    operation: PersistenceOperation,
    workCardDetails: ProjectDetailsWorkCardModel,
    annotation: BasicAnnotation
  ): RoutineWorkCardStepReqModel {
    const { userRole } = this.userAccessor.getEmployeeInfo();
    const verifierType = this.dataHelper.getVerifierTypeFromRole(userRole);

    if (operation === 'DELETE'){
      let lastSelectedAnno = JSON.parse(localStorage.getItem('selectedAnnotation'));
      if ( lastSelectedAnno !== null && lastSelectedAnno.id === annotation.annotationId && lastSelectedAnno.page !== annotation.page){
        annotation.page = lastSelectedAnno.page;
        annotation.x = lastSelectedAnno.lX;
        annotation.y = lastSelectedAnno.lY;
      }
    }

    const step: RoutineWorkCardStepReqModel = {
      operation,
      token: this.getToken(),
      pageNumber: annotation.page,
      positionX: annotation.x,
      positionY: annotation.y,
      documentId: annotation.documentId,
      rtnCardStampsActivityId:
        annotation.customData.IO_RTN_CARD_STAMPS_ACTIVITY_ID ?? null,
      divNo: workCardDetails.DIV_NO,
      workCardId: workCardDetails.WORK_CARD_ID,
      verifierType,
      stampNumber: annotation.customData.STAMP_NUMBER ?? null,
      //annotationType: annotation.type === 'STAMP' ? 'STAMP' : 'ANNOTATION',

      // Should these have values?
      documentType: '',
    };

    switch(annotation.customData.STAMP_TYPE) {
      case 'CIR_STAMP':
        step.annotationType = 'DESIGNATOR'
        break;
      default:
        if (annotation.type === 'STAMP') {
          step.annotationType = 'STAMP'
        } else {
          step.annotationType = 'ANNOTATION';
        }
    }

    if (workCardDetails.persona === 'inspector') {
      step.groupId = workCardDetails.GROUP_ID;
    }

    return step;
  }

  processLogOutByWorkCard(
    payload: LaborClockTrackingReqModel[]
  ) {
    return this.concourseApi.startStopLaborClockService(payload, 'labor-clock');
  }

  private getToken() {
    return sessionStorage.getItem('token');
  }
}

function compactObject(obj: {}) {
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null));
}

function coalesceObjects(...args: {}[]) {
  const compactObjects = args.filter((o) => !!o).map(compactObject);
  return Object.assign({}, ...compactObjects);
}
